import { MenuItemProps, MenuItem, Select, TypographyProps, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

const StyledSelect = styled(Select)<{ noPointer?: boolean }>(({ theme, noPointer }) => ({
  pointerEvents: noPointer ? "none" : "auto",
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.surface.container,
  overflow: "hidden",

  ".MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.surface.silver,
    pointerEvents: noPointer ? "none" : "auto",
    width: "100%",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.border.dark}`,
    borderRadius: theme.spacing(1.5),
  },

  "& .MuiSelect-icon": {
    color: theme.palette.text.secondary,
    fontSize: "24px",
  },

  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.border.dark}`,
    },
  },
}));

export const TestStyledSelect = (props: any) => {
  const theme = useTheme();
  return (
    <StyledSelect
      sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1), minWidth: "fit-content" }}
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: theme.spacing(1.5),
              backgroundColor: theme.palette.surface.silver,
              padding: theme.spacing(0.5, 2),
            },
          },
        },
      }}
      IconComponent={undefined}
      {...props}
    />
  );
};

export const TestMenuItem = (props: MenuItemProps) => {
  const theme = useTheme();
  return (
    <MenuItem sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1) }} {...props}>
      {props.children}
    </MenuItem>
  );
};

export const TestMenuItemTypo = (props: TypographyProps) => {
  const theme = useTheme();

  return (
    <Typography
      variant="body-default"
      color="text.secondary"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
        gap: theme.spacing(1),
        minHeight: "26px",
      }}
      {...props}>
      {props.children}
    </Typography>
  );
};
